import { useNavigate } from "react-router-dom";
import ClientService from "../services/clientService";
import { getSessionDocument } from "services/sessionStorageService";
const clientService = new ClientService();

export const useRedirect = () => {
  const navigate = useNavigate();
  const checkAndRedirect = async (openModalRedirect, estado, params) => {
    const documento = getSessionDocument();
    if (!documento) {
      navigate(`/?` + params);
    } else {
      try {
        const response = await clientService.evaluateDocument(documento);
        const codigoEstado = response.data.codigoEstado;
        const transaction = {
          ...response.data,
        };
        if (codigoEstado != 0 && codigoEstado != estado) {
          openModalRedirect();
          setTimeout(async () => {
            redirectStep(codigoEstado, transaction, navigate, params);
          }, 3000);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  return { checkAndRedirect };
};

export const redirectStep = async (
  codigoEstado,
  transaction,
  navigate,
  params,
) => {
  switch (codigoEstado) {
    case 0:
    case 1:
      navigate(`${URLs.datosPersonales}${params ? "?" + params : ""}`, {
        state: {
          transaction: { ...transaction, codigoPaso: 1 },
        },
      });
      break;
    case 2:
      navigate(`${URLs.datosLaborales}${params ? "?" + params : ""}`, {
        state: {
          transaction: { ...transaction, codigoPaso: 2 },
        },
      });
      break;
    case 3: {
      const responseEstado3 = await clientService.getInfoEstado(transaction);
      const newTransaction = {
        ...transaction,
        tipoDeEmpleoElegido: responseEstado3.data.infoDocumentacion,
        codigoPaso: 3,
      };
      navigateToOfferRedirect(
        newTransaction,
        responseEstado3,
        navigate,
        params,
      );
      break;
    }
    case 4: {
      const responseEstado4 = await clientService.getInfoEstado(transaction);
      const newTransaction = {
        ...transaction,
        tipoDeEmpleoElegido: responseEstado4.data.infoDocumentacion,
        codigoPaso: 4,
      };
      if (responseEstado4.data.requiereDoc === false) {
        navigate(`${URLs.agenciaDeRetiro}${params ? "?" + params : ""}`, {
          state: { transaction: newTransaction },
        });
      } else {
        const productName = getProductNameById(responseEstado4.data.productId);
        navigate(
          `${URLs.solicitarMiTarjeta}/${productName}${
            params ? "?" + params : ""
          }`,
          {
            state: { transaction: newTransaction },
          },
        );
      }
      break;
    }
    case 5: {
      const newTransaction = {
        ...transaction,
        codigoPaso: 5,
      };
      navigate(`${URLs.verificacionCelular}${params ? "?" + params : ""}`, {
        state: { transaction: newTransaction },
      });
      break;
    }
    case 6: {
      const responseEstado = await clientService.getInfoEstado(transaction);
      const productName = getProductNameById(responseEstado.data.productId);
      const newTransaction = {
        ...transaction,
        productName: productName,
        pagoAnticipado: responseEstado.data.ofertaConfirmada.pagoAnticipado,
      };
      setTimeout(() => {
        navigate(`${URLs.costoDeActivacion}${params ? "?" + params : ""}`, {
          state: { transaction: newTransaction },
        });
      }, 4000);
      break;
    }
    default:
      navigate(`${URLs.home}${params ? "?" + params : ""}`);
  }
};

const navigateToOfferRedirect = (transaction, response, navigate, params) => {
  const checkParams = params ? "?" + params : "";
  // if (response.data.productId === 10) {
  //   navigate(`${URLs.ofertaPlataPilotoSinDoc}${checkParams}`, {
  //     state: { transaction: transaction, userData: response.data },
  //   });
  //   return;
  // }
  const nombreProducto = getProductNameById(response.data.productId);
  if (nombreProducto) {
    navigate(`${URLs.oferta}/${nombreProducto}${checkParams}`, {
      state: { transaction: transaction, userData: response.data },
    });
  }
};

export const getProductNameById = (id) => {
  switch (id) {
    case 1:
    case 2:
    case 7:
    case 9:
    case 10:
      return "plata";
    case 3:
    case 4:
      return "oro";
    case 8:
      return "oro-mas";
    case 5:
      return "platino";
    case 6:
      return "platino-mas";
    default:
      return null;
  }
};

export const getURLDespedida = (urlParam) => {
  if (
    urlParam &&
    (urlParam.toLowerCase() === "googleads" ||
      urlParam.toLowerCase() === "facebook")
  ) {
    return URLs.felicitaciones;
  } else if (
    urlParam &&
    (urlParam.toLowerCase() === "googleads2" ||
      urlParam.toLowerCase() === "facebook2")
  ) {
    return URLs.solicitudEnviado;
  } else {
    return URLs.gracias;
  }
};

export const URLs = {
  home: "/",
  datosPersonales: "/datos-personales",
  datosLaborales: "/datos-laborales",
  newDatosLaborales: "/datitos",
  agenciaDeRetiro: "/agencia-de-retiro",
  // ofertaPlataPilotoSinDoc: "/oferta/plata/piloto-sindoc",
  graciasSiisa: "/gracias-siisa",
  oferta: "/oferta",
  solicitarMiTarjeta: "/solicitar-mi-tarjeta",
  adicionales: "/adicionales",
  verificacionCelular: "/verificacion-celular",
  costoDeActivacion: "/costo-de-activacion",
  pendiente: "/pendiente-mp",
  error: "/error-mp",
  gracias: "/gracias",
  felicitaciones: "/felicitaciones",
  rechazada: "/rechazada",
  solicitudEnviado: "/solicitud-enviado",
  errorInesperado: "/error-inesperado",
  enProcesoAprobacion: "/solicitud-en-proceso-de-aprobacion",
  esCliente: "/es-cliente",
  noCalifica: "/no-califica",
  pagoPendiente: "/pago-pendiente",
  intenteLuegoSiisa: "/intente-mas-tarde-siisa-equifax",
  intenteLuego: "/intente-mas-tarde",
  intenteNuevamente: "/verificacion-celular-intenta-nuevamente",
  solicitudEnCurso: "/solicitud-en-curso",
};
